




































import { Component, Vue, Watch } from 'vue-property-decorator';
import Logo from '@/assets/logo.svg';
import AuthService from '@/services/auth';
import FloatLabelInput from '@/components/FloatLabelInput.vue';

@Component({
  components: {
    FloatLabelInput,
    Logo,
  },
})
export default class Login extends Vue {
  authService = new AuthService();

  loading = false;

  email: string = null;

  password: string = null;

  authFailed = false;

  mounted() {
    if (this.authService.isLoggedIn) {
      this.redirect(true);
    }
  }

  login() {
    this.loading = true;

    this.authService
      .login(this.email, this.password)
      .catch(({ response }) => {
        if (response.status === 400) {
          this.password = '';
          this.$nextTick(() => {
            this.authFailed = true;
          });
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  @Watch('email')
  @Watch('password')
  resetAuthFailure() {
    this.authFailed = false;
  }

  @Watch('authService.isLoggedIn')
  redirect(loggedIn: boolean) {
    if (loggedIn) {
      this.$router.push({
        name: 'Cars',
      });
    }
  }
}
